module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone_selected.68eb65ac.svg";